<template>
  <div
    id="total-control"
    v-loading="vLoading">
    <div class="header">
      <div
        class="title"
        @click="goBack">
        <span class="el-icon-arrow-left"></span><span>Adjust Subscription</span>
      </div>
    </div>
    <div
      class="current-wrap"
      v-if="!type || type == 'current'">
      <div class="edit-left">
        <div class="plan-total">
          Current no.
        </div>
        <div
          class="plan-price"
          v-if="from != 'dashboard'">
          ${{ price }} /per channel per {{ cycle }}
        </div>
      </div>
      <div class="edit-right">
        <div
          class="tools reduce"
          :class="currentSub == initsubnums ? 'limit':''"
          @click="(e) => handleCurrentTotal(e, false)"><i class="el-icon-remove"></i></div>
        <el-input
          :value="currentSub"
          @input="currentInput"
          type="number">
        </el-input>
        <div
          class="tools add"
          @click="(e) =>  handleCurrentTotal(e, true)"><i class="el-icon-circle-plus"></i></div>
      </div>
    </div>
    <div
      class="next-wrap"
      v-if="(!disableNext && (!type || type=='next'))">
      <div class="edit-left">
        <div class="plan-total">
          Next billing date:
        </div>
        <div
          class="plan-price"
          v-if="from != 'dashboard'">
          ${{ price }} /per channel per {{ cycle }}
        </div>
      </div>
      <div class="edit-right">
        <div
          class="tools reduce"
          :class="nextSub == 0 ? 'limit':''"
          @click="(e) => handleNextTotal(e, false)"><i class="el-icon-remove"></i></div>
        <el-input
          v-model="nextSub"
          type="number"></el-input>
        <div
          class="tools add"
          @click="(e) =>  handleNextTotal(e, true)"><i class="el-icon-circle-plus"></i></div>
      </div>
    </div>
    <div class="card-footer">
      <el-button @click="goBack">Go back</el-button>
      <el-button
        class="confirm-box"
        @click="handleConfirm">Confirm</el-button>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
export default {
  props: {
    initsubnums: Number,
    pretreatmentQuantity: Number,
    price: Number,
    cycle: String,
    from: String,
    vLoading: Boolean,
    type: String,
    tryOut: Boolean // 试用
  },
  data () {
    return {
      currentSub: 0,
      nextSub: 0,
      currentInputTimer: null,
      currentInputNumber: null
    }
  },
  computed: {
    disableNext () {
      return this.tryOut || this.initsubnums == 0
    }
  },
  created () {
    this.currentSub = this.initsubnums
    this.nextSub = this.pretreatmentQuantity
  },
  methods: {
    goBack () {
      this.$emit('goBack')
    },
    handleCurrentTotal (e, type) {
      e.preventDefault()
      if (type) {
        this.currentSub++
        // 这个月增加 覆盖下个月的数量
        this.nextSub = this.currentSub
      } else if (this.currentSub > this.initsubnums) {
        this.currentSub--
        this.nextSub = this.currentSub
      }
    },
    currentInput (e) {
      if (this.currentInputTimer) {
        clearTimeout(this.currentInputTimer)
      } else {
        this.currentInputNumber = this.currentSub
      }
      this.currentSub = e
      this.currentInputTimer = setTimeout(() => {
        if (this.currentSub < this.initsubnums) {
          this.currentSub = this.currentInputNumber
          Message.warning('invalid inputs')
        } else {
          this.nextSub = this.currentSub
        }
        this.currentInputTimer = null
      }, 1000)
    },
    handleNextTotal (e, type) {
      e.preventDefault()
      if (type) {
        this.nextSub++
      } else if (this.nextSub >= 1) {
        this.nextSub--
      }
    },
    handleConfirm () {
      if (this.currentSub == this.initsubnums && this.nextSub == this.pretreatmentQuantity) return false
      this.$emit('confirm', {
        initsubnums: Number(this.currentSub),
        pretreatmentQuantity: Number(this.nextSub)
      })
    }
  }
}
</script>

<style lang="less" scoped>
#total-control {
  position: relative;
  height: 460px;
  .header {
    position: absolute;
    width: fit-content;
    top: -60px;

    .title {
      line-height: 24px;
      font-weight: 700;
      font-size: 18px;
      color: var(--dialog-text-color);
      cursor: pointer;
    }
    .el-icon-arrow-left {
      font-weight: 900;
    }
  }
  .card-footer {
    margin: 120px 0 20px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
    /deep/ .el-button {
      background: #fff0;
      color: #2c3e50;
      width: fit-content;
      border: 1px solid #dbdbdb;
      color: var(--table-button-text-color);
      border-color: var(--table-button-border-color);
      background-color: var(--table-button-bg);
    }
    .confirm-box {
      background: #33AB4F;
      color: #FFFFFF;
    }
  }

  .current-wrap, .next-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    .edit-left {
      margin-left:15px;
      text-align: left;
      width: 60%;
      .plan-total {
        font-weight: 600;
        color: var(--text-color-01);
      }
      .plan-price {
        font-size: 12px;
        color: #999;
      }
    }
    .edit-right {
      // width: 130px;
      text-align: right;
      display: flex;
      .current {
        color: var(--text-color-01);
        font-weight: 500;
      }
      .next {
        font-size: 12px;
        line-height: 14px;
        color: #999999;
      }
      .tools {
        font-size: 20px;
        margin: 0 5px;
        cursor: pointer;
      }
      .add {
        color: #33AB4F;
      }
      .limit {
        color: #DBDBDB;
        cursor: not-allowed;
      }
    }
  }
}
</style>
